<template>
  <AdListingView :loaded="loaded" :empty="empty" :h1="h1" :items="list" />
</template>

<script setup>
import AdListingView from '~/components/cmsCustomer/advertisement/display/AdListingView.vue'

const { loaded, empty, h1, list } = await useAdListing({ category: true, subcategory: true })
</script>
